module.exports = __webpack_public_path__ + "img/e8734bb695bc1742fbc19544e5cbe33-1.187230ad.jpg";